import React, { useState } from 'react';

export default function selectInput({
  curValue,
  config,
  updateValue,
  formData,
  colSize
}) {
  const [value, setValue] = useState(curValue);
  const { label, options } = config;

  const optionsList = options.map((opt) => {
    if (typeof opt === 'string') {
      return (
        <option key="Please Choose" value="Please Choose">
          Please Choose
        </option>
      );
    } else if (typeof opt === 'object') {
      let label, utmCode;
      for (const [key, value] of Object.entries(opt)) {
        label = key;
        utmCode = value;
      }

      return (
        <option key={utmCode} value={utmCode}>
          {label}
        </option>
      );
    }
  });

  const handleChange = (event) => {
    if (event.target.value === 'Please Choose') return;

    setValue(event.target.value);
    updateValue({ ...formData, [label]: event.target.value });
  };

  // Return Value to Parent
  const style = `grid__col-lg-${colSize} u--padding-0`;

  return (
    <div className={style}>
      <div className="form__field  u--margin-bottom-0 notransition">
        <div className="utm__form__select">
          <select value={value} onChange={(event) => handleChange(event)}>
            {optionsList}
          </select>
        </div>
      </div>
    </div>
  );
}
